import React from 'react'
import { useTransition, animated } from 'react-spring'
import BetCard from './BetCard'
import { removeFromSlip, updateOrder } from './utilities.js'

const ActiveBets = activeBetProps => {
  const { data, set, disabled } = activeBetProps

  const bets = Object.keys(data.betslip).map(item => data.betslip[item])

  const BetCardAnimation = useTransition(
    bets,
    item => `${item.id}-${item.marketIndex}-${item.buttonIndex}`,
    {
      config: { tension: 250 },
      from: { opacity: 0 },
      enter: { opacity: 1 },
      leave: { opacity: 0 },
    }
  )

  return BetCardAnimation.reverse().map(({ item, key, props }) => {
    const stake = parseFloat(item.stake) || 0
    return (
      <animated.div key={key} style={props}>
        <BetCard
          disabled={disabled}
          editable
          id={item.id}
          sport={item.sport}
          competition={item.competition}
          marketTitle={item.marketTitle}
          name={item.name}
          odds={item.odds}
          slug={item.slug}
          date={item.date}
          start={item.start}
          freebet={data.user.freebet}
          returns={item.returns || 0}
          stake={stake}
          inputHandler={userStake =>
            updateOrder(
              data,
              set,
              item.id,
              item.marketIndex,
              item.buttonIndex,
              item.odds,
              userStake
            )
          }
          clickHandler={() =>
            removeFromSlip(
              data,
              set,
              item.id,
              item.marketIndex,
              item.buttonIndex
            )
          }
        >
          {item.name}
        </BetCard>
      </animated.div>
    )
  })
}

export default ActiveBets
